var _classCallCheck = require("/home/forge/bpfd-stage.parallelpublicworks.com/frontend/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/forge/bpfd-stage.parallelpublicworks.com/frontend/node_modules/@babel/runtime/helpers/createClass");

var buildQueryString = require('d8-jsonapi-querystring').buildQueryString;

var SubRequests = /*#__PURE__*/function () {
  "use strict";

  function SubRequests(endpoint) {
    _classCallCheck(this, SubRequests);

    this.autoincrementedId = 0;
    this.endpoint = endpoint;
    this.requests = [];
  }

  _createClass(SubRequests, [{
    key: "add",
    value: function add(request) {
      // only add this request if this requestId is not already in the pipe
      var existing = this.requests.find(function (item) {
        return item.requestId == request.requestId;
      });
      if (existing) return;
      var defaultOptions = {
        action: "view",
        headers: {
          Accept: "application/json"
        }
      };
      var subrequest = Object.assign(defaultOptions, request);

      if (subrequest.options) {
        subrequest.uri = subrequest.uri + '?' + buildQueryString(subrequest.options);
      } // generate automatically a requestId if needed


      if (subrequest.requestId === undefined) {
        subrequest.requestId = ++this.autoincrementedId;
      }

      this.requests.push(subrequest);
    }
  }, {
    key: "textToBinary",
    value: function textToBinary(string) {
      return string.split('').map(function (char) {
        return char.charCodeAt(0).toString(2);
      }).join(' ');
    }
    /**
     * @param {string} response : raw *body* of the http response sended by subrequests drupal module
     */

  }, {
    key: "parseResponse",
    value: function parseResponse(responseBody) {
      var boundary = responseBody.split('\n')[0].trim();
      var responses = responseBody.split(boundary).filter(function (v) {
        return v !== "" && v !== '--';
      }).map(function (v) {
        return JSON.parse(v.split("\n\r")[1]);
      });
      return responses;
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      var blueprint = JSON.stringify(this.requests);
      var url = this.endpoint + '&query=' + encodeURIComponent(blueprint);
      return url;
    }
  }]);

  return SubRequests;
}();

module.exports = SubRequests;